export default {
    serverLabels: {},
    notifications: {}
}